// Frontend-only mock for now — no backend adapter exists yet. 

export type CameraStatus = 'live' | 'offline' | 'alert';

export interface ICamera {
  id: string;           // Stable camera identifier, e.g. "CAM-04"
  name: string;         // Human label, e.g. "Level 8 — MEP Zone"
  zone: string;         // Sub-location within the floor
  floor: string;        // Floor code used for filtering + the feed-tile label
  level: number;        // Absolute vertical position of the floor
  status: CameraStatus;
  alertLabel?: string;  // Short violation label shown on an alerting tile, e.g. "PPE violation"
  videoSrc?: string;    // Optional looping demo clip; when set, plays in place of the placeholder
}

export const CAMERA_STATUS_COLOR: Record<CameraStatus, string> = {
  live: 'var(--blue)',
  offline: 'var(--amber)',
  alert: 'var(--red)',
};

export type CameraEventSeverity = 'high' | 'medium' | 'low';

export interface ICameraEvent {
  id: string;
  title: string;
  time: string;
  cameraId: string;
  location: string;
  severity: CameraEventSeverity;
}

export const CAMERA_EVENT_SEVERITY_COLOR: Record<CameraEventSeverity, string> = {
  high: 'var(--red)',
  medium: 'var(--amber)',
  low: 'var(--blue)',
};

export type CameraGridSize = 2 | 3 | 4;
